module.exports = __webpack_public_path__ + "static/media/ic_notification_danger.16158329.svg";